import { render, staticRenderFns } from "./PositionCard.vue?vue&type=template&id=5d81b088&"
import script from "./PositionCard.vue?vue&type=script&lang=js&"
export * from "./PositionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports